import { getLocalContext } from '@thoughtspot/blink-context';
export var SparkflowActionType;
(function (SparkflowActionType) {
    SparkflowActionType[SparkflowActionType["UPDATE_WORKSPACE_ID"] = 0] = "UPDATE_WORKSPACE_ID";
    SparkflowActionType[SparkflowActionType["UPDATE_SETTINGS"] = 1] = "UPDATE_SETTINGS";
    SparkflowActionType[SparkflowActionType["UPDATE_ONBOARDING_SELECTIONS"] = 2] = "UPDATE_ONBOARDING_SELECTIONS";
    SparkflowActionType[SparkflowActionType["UPDATE_BUILD_INFO"] = 3] = "UPDATE_BUILD_INFO";
})(SparkflowActionType || (SparkflowActionType = {}));
export const initialSparkflowConfig = {
    rootPath: '',
    navigationCB: null,
    selectedWorkspaceId: '',
    settings: {
        theme: 'light',
        enableNotifications: true,
    },
    onboardingSelections: {
        selectedFunction: '',
        selectedIndustry: '',
    },
    buildInfo: {
        liveboardId: '',
        modelId: '',
        tableId: '',
        industry: '',
        function: '',
    },
};
const reducer = (state = initialSparkflowConfig, action) => {
    switch (action.type) {
        case SparkflowActionType.UPDATE_WORKSPACE_ID:
            return {
                ...state,
                selectedWorkspaceId: action.data,
            };
        case SparkflowActionType.UPDATE_SETTINGS:
            return {
                ...state,
                settings: {
                    ...state.settings,
                    ...action.data,
                },
            };
        case SparkflowActionType.UPDATE_ONBOARDING_SELECTIONS:
            return {
                ...state,
                onboardingSelections: {
                    ...state.onboardingSelections,
                    ...action.data,
                },
            };
        case SparkflowActionType.UPDATE_BUILD_INFO:
            return {
                ...state,
                buildInfo: {
                    ...state.buildInfo,
                    ...action.data,
                },
            };
        default:
            return {
                ...state,
            };
    }
};
const getDispatcherFunctions = (dispatch) => {
    const updateWorkspaceId = (workspaceId) => {
        dispatch({
            type: SparkflowActionType.UPDATE_WORKSPACE_ID,
            data: workspaceId,
        });
    };
    const updateSettings = (settings) => {
        dispatch({
            type: SparkflowActionType.UPDATE_SETTINGS,
            data: settings,
        });
    };
    const updateOnboardingSelections = (selections) => {
        dispatch({
            type: SparkflowActionType.UPDATE_ONBOARDING_SELECTIONS,
            data: selections,
        });
    };
    const updateBuildInfo = (buildInfo) => {
        dispatch({
            type: SparkflowActionType.UPDATE_BUILD_INFO,
            data: buildInfo,
        });
    };
    return {
        updateWorkspaceId,
        updateSettings,
        updateOnboardingSelections,
        updateBuildInfo,
    };
};
const { TrackedContextProvider: SparkflowContextProvider, getTrackedState: getSparkflowConfig, getTrackedMethods: setSparkflowConfig, } = getLocalContext('sparkflow-context', reducer, initialSparkflowConfig, getDispatcherFunctions);
export { SparkflowContextProvider, getSparkflowConfig, setSparkflowConfig };
//# sourceMappingURL=sparkflow-context.js.map